import { render, staticRenderFns } from "./recycleWord.vue?vue&type=template&id=367cc04f&scoped=true&"
import script from "./recycleWord.vue?vue&type=script&lang=js&"
export * from "./recycleWord.vue?vue&type=script&lang=js&"
import style0 from "./recycleWord.vue?vue&type=style&index=0&id=367cc04f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367cc04f",
  null
  
)

export default component.exports